h3-feedback-panel{max-height:calc(100vh - 16px)}
/*# sourceMappingURL=field-feedback-list.component.css.map */
